import {  ASSET_NAVIGATION_LIST } from './NavigationTypes'
export const setMenuListAssetInventory = (menuListAssetInventory: any) => {
  return {
    type: ASSET_NAVIGATION_LIST,
    payload: menuListAssetInventory
  }
}
